export const CATEGORY_FACET_ID = 31;
export const COLOR_FACET_ID = 2;
export const CLOSE_MENU_PSEUDO_FACET_ID = -1;
export const PRICE_PSEUDO_FACET_ID = -2;

export const PRIORITIZE_THIS_JOB = -1;
export const RESET_CATEGORY_JOB = -2;
